import { render, staticRenderFns } from "./LoginComplete.vue?vue&type=template&id=b676f052"
import script from "./LoginComplete.vue?vue&type=script&lang=js"
export * from "./LoginComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports